import { DOCUMENT } from '@angular/common';
import { Component, Inject, OnInit, Renderer2 } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

import { AuthenticationService, CookieService, Platform, CommonPlatformService, PlatformUserDto, SelectUserDTO } from 'psd-common';
import { environment } from '../../../../environments/environment';

@Component({
  styleUrls: ['central-login-select-account.component.css'],
  selector: 'central-login-join',
  templateUrl: 'central-login-select-account.component.html'
})
export class CentralLoginSelectAccountComponent implements OnInit {
  public platformUsers: Array<PlatformUserDto>;
  public currentPlatform: Platform;
  public prefix: string;
  public error: string;

  constructor(@Inject(DOCUMENT) private document: Document,
              private renderer: Renderer2,
              private route: ActivatedRoute,
              private platformService: CommonPlatformService,
              private authenticationService: AuthenticationService,
              private cookieService: CookieService,
              private router: Router) {
  }

  ngOnInit() {
    this.renderer.addClass(this.document.body, 'login');
    let centralAccessToken = this.cookieService.getCentralCookie('central_access_token', environment.production);

    this.route.queryParams.subscribe(_params => {
      this.prefix = _params.platform;
      this.error = _params.error;
      if(this.prefix) {
        this.platformService.getExternalPlatformDetails(this.prefix).subscribe(_platform => {
          this.currentPlatform = _platform;

          this.authenticationService.loadCurrentPossibleUsers(centralAccessToken, this.currentPlatform?.name).subscribe(_users => {
            this.platformUsers = _users;
          });
        });
      }
    });
  }

  selectUser(platformUserDto: PlatformUserDto) {
    let centralAccessToken = this.cookieService.getCentralCookie('central_access_token', environment.production);
    let centralRefreshToken = this.cookieService.getCentralCookie('central_refresh_token', environment.production);
    let selectUserDTO = new SelectUserDTO();
    selectUserDTO.userId = platformUserDto.platformUserId;
    selectUserDTO.platformId = platformUserDto.platformId;

    this.authenticationService.selectUser(selectUserDTO, centralAccessToken, platformUserDto.apiURL).subscribe(_result => {
      // @ts-ignore
      let platformForm: HTMLFormElement = document.getElementById('goToPlatformForm');
      platformForm.action = platformUserDto.platformURL + '/index.php';
      platformForm['central_access_token'].value = centralAccessToken;
      platformForm['central_refresh_token'].value = centralRefreshToken;
      platformForm['access_token'].value = _result.access_token;
      platformForm['refresh_token'].value = _result.refresh_token;
      platformForm['expires_in'].value = _result.expires_in;
      platformForm['force_token_refresh'].value = 'true';
      platformForm.submit();
    });
  }
}

